/** @jsx h */
import { h } from 'preact'

const ShareIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='22'
      height='22'
      viewBox='0 0 22 22'
    >
      <g
        fill='none'
        fillRule='evenodd'
        stroke='currentColor'
        strokeLinecap='round'
        strokeWidth='1.5'
      >
        <path
          strokeLinejoin='round'
          d='M0 11.111V20h20v-8.889M6.111 3.333L10 0l3.889 3.333'
          transform='translate(1 1)'
        />
        <path d='M10 11.111V0' transform='translate(1 1)' />
      </g>
    </svg>
  )
}

export default ShareIcon
